import { useFetch } from "~vue/api";
import type { PerformanceReviewRelationship } from "~vue/types/performance_management";

export const usePerformanceReviewRelationships = () => {
    const fetchUrl = "/api/coach/performance_reviews/relationships/";
    return useFetch(fetchUrl, { refetch: true }).get().json<{ relationships: Array<PerformanceReviewRelationship> }>();
};
